import React, { useEffect, useState } from "react";
import { Button, message, Modal, Alert} from "antd";
import _StudentService from "../../modules/StudentService";
import _notification from 'modules/notification';
import PaymentModal from "../../views/popup/PaymentModal";
// Phase C.5 (Candidate System UI Language Migration): moved this control's own hardcoded
// English+Marathi "Payment" button onto the centralized Text/dictionary.js architecture.
import Text from 'components/Text/Text';


export default function PaymentsIOBCCAvenue(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [paymentPath, setPaymentPath] = useState("");
  const [show, setShow] = useState(false);
  const [isPaymentDisabled, setIsPaymentDisabled] = useState(false);
  const [isdisabledMessage, setIsDisabledMessage] = useState(false);
  // Phase R6.5 (DEMO / Mock Payment Mode): true only when the backend's active provider is the DEMO
  // gateway and it has already recorded a successful transaction synchronously — there is no real
  // gateway iframe to show in that case.
  const [isDemoAutoSuccess, setIsDemoAutoSuccess] = useState(false);


  useEffect(() => {
    initiatePaymentRequest();
  }, []);

  const checkPayment = () => {
    try {
      let response = _StudentService.verifyPaymentStatus().then(
        function (value) {
          if (value.status == 200 && value.data.IsSuccess) {
            setIsLoading(false);
            props.onTabOrderChange();
          } else {
            message.error("Your payment was failed/aborted. Please contact customer support if money deducted from account.")
            initiatePaymentRequest();
          }
        },
        function (error) {
          message.error("Your payment was failed/aborted. Please contact customer support if money deducted from account.");
          console.log("checkPayment error => function =>", error);
        }
      );
    } catch (e) {
      message.error("Error occured while initiating payment, please contact Admin.");
      console.log("checkPayment e => catch =>", e);
    }
  }


  const initiatePaymentRequest = () => {
    try {
      let response = _StudentService.initiagePaymentRequest().then(
        function (value) {
          // Phase R6.5: the DEMO gateway already recorded a successful transaction synchronously —
          // there is no gateway iframe to show, so navigate straight to the same post-payment route
          // (/transactionprocess) a real gateway would eventually redirect back to. AfterPayment.jsx
          // needs no changes: it polls the authenticated candidate's own latest transaction, which the
          // DEMO provider already persisted as Success.
          if (value.status == 200 && value.data && value.data.IsDemoAutoSuccess) {
            setIsLoading(false);
            setIsDemoAutoSuccess(true);
            window.location.href = '/transactionprocess';
          } else if (value.status == 200 && value.data && value.data.IframePath && value.data.IframePath !== "") {
            setIsLoading(false);
            setPaymentPath(value.data.IframePath);
            setIsPaymentDisabled(value.data.IsPaymnetDisabled);
          } else {
            setIsLoading(false);
            setIsPaymentDisabled(true);
            message.error(value.data.Message ? value.data.Message :"Error occured while initiating payment, please contact Admin.");
            console.log("error => function =>",);
          }
        },
        function (error) {
          message.error("Error occured while initiating payment, please contact Admin.");
          console.log("error => function =>", error);
        }
      );
    } catch (e) {
      message.error("Error occured while initiating payment, please contact Admin.");
      console.log("initiatePaymentRequest e => catch =>", e);
    }
  }

  const initPayment = () => {
    let openInFrame = true;
    if (openInFrame) {
      if (isPaymentDisabled) {
        setIsDisabledMessage(true);
      } else {
        setShow(true);
      }
    } 
    else {
      var new_window = window.open(paymentPath, "", "width=900,height=700")

      var timer = setInterval(function () {
        if (new_window.closed) {
          clearInterval(timer);
          // checkPayment();
        }
      }, 1000);
    }

  };


  const handlePayment = async () => {
    try {
      initPayment();
    } catch (error) {
      message.error("Error occured while initiating payment, please contact Admin.");
      console.log("handlePayment error => catch =>", error);
    }
  };

  const onOk = async () => {
    setIsDisabledMessage(false);
  };


  return (
    <>
      {show &&
        <Modal
          centered={true}
          width={600}
          //height={600}
          bodyStyle={{ height: '550px', padding: 0, alignItems: 'center', justifyContent: 'center', display: ' flex' }}
          className="modelPopAnt"
          visible={show}
          closable={false}
          footer={false}
        >
          <PaymentModal paymentPath={paymentPath}></PaymentModal>{" "}
        </Modal>}

      {isdisabledMessage &&
        <Modal visible={isdisabledMessage}
          closable={false}
          width={600}
          centered={true}
          footer={
            <Button type="primary" onClick={onOk}>
              Close
            </Button>
          }
        >
          <Alert
            message="Payment Closed"
            description="New Applications Are Closed For This Process."
            type="error"
          />
        </Modal>}

      <Button
        id="btnSubmit"
        className={props.isDisabled? "button-global button-border autoHeight disabled" : "button-global button-primary autoHeight " }
        type="primary"
        value="Payment"
        disabled={props.isDisabled || isDemoAutoSuccess}
        onClick={handlePayment}
        loading={isLoading}><div className='displayInGrid'>
          <Text k="submitForm.paymentButton" /></div>
      </Button>
    </>
  );
}